export default __webpack_public_path__ + "static/media/QueenThBackground.9959f01e.png";